export type themeTypes = "darkTheme" | "lightTheme";
export function getInitialTheme() {
  const storedTheme = localStorage.getItem("theme") as themeTypes;
  return storedTheme || "lightTheme";
}
